import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch',
  standalone: true,
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, searchTerm: string): SafeHtml {
    if (!searchTerm || !text) {
      return this.sanitizer.bypassSecurityTrustHtml(text);
    }

    // Escape special regex characters in the search term
    const safeSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Create a regex that is case-insensitive
    const regex = new RegExp(`(${safeSearchTerm})`, 'gi');

    // Replace matching text with <mark> tags
    const newText = text.replace(regex, '<mark class="bg-rose-200 dark:bg-rose-700 px-0.5 rounded">$1</mark>');

    // Make the result safe for insertion into HTML
    return this.sanitizer.bypassSecurityTrustHtml(newText);
  }
}
